<h1 ev-dialog-title data-testid="nav-disclaimer-title">{{ languageService.languageJSON.NavigationDisclaimerDialog_Title }}</h1>

<div ev-dialog-content class="scrollable" data-testid="nav-disclaimer-container">
  <div class="disclaimer-content">
    <app-modal-option-panel>
      <p class="disclaimer-text">
        {{ languageService.languageJSON.NavigationDisclaimerDialog_Description }}
      </p>
    </app-modal-option-panel>
  </div>
</div>

<div ev-dialog-actions>
  <button class="ev-button primary" name="ok_button" mat-button data-testid="nav-disclaimer-accept-btn" (click)="accept()">
    {{ languageService.languageJSON.Global_Accept }}
  </button>
  <button class="ev-button" name="cancel_button" mat-button data-testid="nav-disclaimer-cancel-btn" (click)="cancel()">
    {{ languageService.languageJSON.Global_Cancel }}
  </button>
</div>
